import axios from "../axiosPlugin.js";

export const getCustomizeTicketService = (data, loading = false, isDefaultAlertTips = false) => {
  return axios({
    url: "/api/customizeTicket/current",
    method: "get",
    data: {
      data,
      loading,
      isDefaultAlertTips,
    },
  });
};

export const updateCustomizeTicketService = (data, loading = true) => {
  return axios({
    url: "/api/customizeTicket/update",
    method: "put",
    data: {
      data,
      loading,
    },
  });
};